import * as React from "react";

import { Link } from "react-router-dom";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Breadcrumbs, Typography, Stack } from "@mui/material";

import styles from "./Breadcrumb.module.scss";

export default function Breadcrumb({ breadcrumbs = [] }) {
  return (
    <Stack justifyContent="center" spacing={0.5} width="100%" height="8.8rem">
      <Breadcrumbs separator={<KeyboardArrowRightIcon fontSize="1.2rem" />} aria-label="breadcrumb">
        {breadcrumbs.map((b, i) => (
          <Link key={b.title} to={b.link} className={i !== breadcrumbs.length - 1 ? styles.breadcrumb : ""}>
            <Typography fontSize={["1.4rem"]}>{b.title}</Typography>
          </Link>
        ))}
      </Breadcrumbs>
    </Stack>
  );
}
